//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    
    data(){
        return {
            info:{
                wait_rebate:'0.00',
                hand_fee:'0.00',
                nickname:'',
                name:'',
                ids:'',
            },
            ids:'',
            type:0,
            amount:0,
            status:true,
        }
    },
    mounted(){
        this.ids = this.$route.query.ids;
        this.type = this.$route.query.type;
        this.withdrawMoney();
    },
    methods: {
        withdrawMoney(){
            this.$api.withdrawMoney({ids:this.ids,type:this.type}).then((res)=>{
                if(res){
                    this.info = res.data;
                    this.amount = this.info.wait_withdraw;
                }
            });
        },
        submitWithdraw(){
            if(!this.status){
                return false;
            }
            this.status = false;
            if(!this.info.name){
                this.$func.showToast('请输入真实姓名');
                return false;
            }
            if(this.amount <= 0){
                this.$func.showToast('提现金额不正确');
                return false;
            }
            if(this.amount > this.info.wait_withdraw){
                this.$func.showToast('可提现金额不足');
                return false;
            }
            if(this.amount > 5000){
                this.$func.showToast('单次提现限额5000元');
                return false;
            }
            this.$func.confirm('确认提交申请？','提示',()=>{
                 this.$api.submitWithdraw({name:this.info.name,ids:this.ids,type:this.type,amount:this.amount}).then((res)=>{
                    if(res){
                        this.status = true;
                        setTimeout(()=>{
                            this.$router.push({path: '/withdrawComplete', query: {grade: res.data.grade}});
                        }, 300);
                    }
                });
            })
        },
    },
}



// WEBPACK FOOTER //
// ./src/pages/withdraw.vue